import {getAll, getOneById, createOne, patchOne} from './common_requests'

const MAIL_ORDERS_URL = '/mail-orders'

export const getMailOrders = (query: any) => getAll(query, MAIL_ORDERS_URL)

export const getMailOrderDetails = (id: string) => getOneById(id, MAIL_ORDERS_URL)

export const createMailOrder = (payload: any) => createOne(payload, MAIL_ORDERS_URL)

export const updateMailOrder = (id: string, payload: any) =>
  patchOne(payload, `${MAIL_ORDERS_URL}/${id}`)

export const cancelMailOrder = (id: string) => patchOne({}, `${MAIL_ORDERS_URL}/${id}/cancel`)

export const sendInstallmentLink = (id: string, installmentId: string) =>
  createOne({}, `${MAIL_ORDERS_URL}/${id}/installments/${installmentId}/send`)
